import {Frontend} from "./frontend";

(function () {
    XonBoard.Zones = {
        list: {

            selectors: {
                zones_table: $('#zones-table'),
                count_label: $('#count-label'),
            },

            init: function () {

                let self = this;
                let table = this.selectors.zones_table.DataTable({
                    bInfo: false,
                    bLengthChange: false,
                    processing: true,
                    serverSide: true,
                    ajax: {
                        url: this.selectors.zones_table.data('ajax_url'),
                        type: 'post',
                        dataSrc(json) {
                            self.updateCount(json.recordsFiltered);
                            return json.data;
                        }
                    },
                    columns: [
                        {data: 'name', name: 'zones.name'},
                        {
                            data: 'latitude',
                            name: 'zones.latitude',
                            searchable: false,
                            sortable: false,
                            render: (latitude, type, zone) => XonBoard.Map.locationCell(latitude, zone.longitude)
                        },
                        {data: 'status', name: 'zones.status'},
                        {data: 'actions', name: 'actions', searchable: false, sortable: false}
                    ],
                    order: [[0, "asc"]],
                    searchDelay: 500,
                    dom: 'lBfrtip',
                    "createdRow": function (row, data, dataIndex) {
                         Frontend.Utils.dtAnchorToForm(row);
                    }
                });

                XonBoard.Utils.Select2.init();
                Frontend.DataTable.init(table);
                Frontend.DataTableSearch.init(table);
            },
            updateCount(total) {
                this.selectors.count_label.text(total);
            },
        },

        edit: {
            selectors: {},

            init: function (locale) {
                this.addHandlers(locale);
                XonBoard.tinyMCE.init(locale);
            },

            addHandlers: function (locale) {
            },
        },
    }
})();
